import type { MutableRefObject } from "react";
import { useBounds } from "../accessibility/useBounds.js";
import { useDeviceInfo } from "../accessibility/DeviceInfoContext.js";


export type GameLayoutType = "landscape" | "square" | "portrait";


export function useGameLayout(containerRef: MutableRefObject<HTMLDivElement | null>) {
    const deviceInfo = useDeviceInfo();
    const containerBounds = useBounds(containerRef);
    if (!containerBounds)
        return "portrait";

    const width = containerBounds.width;
    const height = containerBounds.height;
    if (width > 26 * deviceInfo.remToPx && width > 1.1 * height)
        return "landscape";
    if (width < 0.8 * height)
        return "portrait";
    return "square";
}
